export default __webpack_public_path__ + "static/media/0092.00d15787.jpg";